import { useEffect, useState } from 'react';
import { getChatNextSteps } from '../../api/chatNextStepsApi';

export default function useGeneratedNextSteps({ messages, sessionId, busy, onCurrentArtifact }) {
  const [generated, setGenerated] = useState(null);
  const last = messages[messages.length - 1];
  const artifactMessage = [...messages].reverse().find((message) => message.artifactId || message.artifactDisplay?.artifactId)
    || [...messages].reverse().find((message) => message.referencedArtifactId);
  const artifactId = artifactMessage?.artifactId || artifactMessage?.referencedArtifactId || artifactMessage?.artifactDisplay?.artifactId || null;
  const ready = !busy && last?.role === 'assistant' && last.answerConfirmed !== false
    && (!last.jobStatus || ['done', 'completed_with_errors'].includes(last.jobStatus));
  const signature = JSON.stringify([sessionId, artifactId, last?.id, last?.content, last?.artifactId,
    last?.referencedArtifactId, last?.artifactDisplay, last?.companies,
    artifactMessage?.artifactDisplay, artifactMessage?.companies]);

  useEffect(() => {
    let cancelled = false;
    if (!sessionId || !ready) return undefined;
    getChatNextSteps(sessionId, artifactId).then(async (response) => {
      if (cancelled) return;
      const currentArtifactId = response?.status === 200 && response.data?.current_artifact_id;
      if (currentArtifactId && currentArtifactId !== artifactId) {
        setGenerated({ signature, suggestions: [] });
        if (onCurrentArtifact) await onCurrentArtifact(currentArtifactId, () => cancelled);
        return;
      }
      const suggestions = response?.status === 200 && Array.isArray(response?.data?.suggestions)
        ? response.data.suggestions.filter((suggestion) => !artifactId || !suggestion.artifact_id || suggestion.artifact_id === artifactId) : [];
      setGenerated({ signature, suggestions });
    }).catch(() => {
      if (!cancelled) setGenerated({ signature, suggestions: [] });
    });
    return () => { cancelled = true; };
  }, [sessionId, artifactId, ready, signature, onCurrentArtifact]);

  return messages.map((message) => ({ ...message, suggestions: ready && message.id === last?.id && generated?.signature === signature
    ? generated.suggestions : [] }));
}
